import { isRejectedWithValue } from '@reduxjs/toolkit';

import { PDF_EXPORT_ENDPOINT_NAMES } from 'store/pdfExport';
import { logout } from 'store/entities/users/slice';

export const rtkQueryErrorMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (
      isRejectedWithValue(action) &&
      !!action?.payload?.status &&
      action.payload.status >= 500 &&
      !PDF_EXPORT_ENDPOINT_NAMES.includes(action.meta?.arg?.endpointName)
    ) {
      dispatch(logout());
    }

    return next(action);
  };
